<template>
  <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      append-to-body
      title="创建要货计划"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form ref="form" :model="form" label-width="50px" :rules="ruleValidate">
      <el-row>
        <el-col :span="12">
          <el-form-item label="标题" prop="billTitle">
            <el-input v-model="form.billTitle"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input v-model="form.note" type="textarea" rows="1"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button type="primary" style="margin-bottom: 10px" @click="$refs.purchaseSelect.open()">新增</el-button>
    <el-table :data="form.details" border>
      <el-table-column
          prop="purchaseOrderNo"
          align="center"
          label="采购订单"
          show-overflow-tooltip
          width="100"/>
      <el-table-column prop="poDetailRowNo" align="center" label="行号" width="80"/>
      <el-table-column
          prop="materialNo"
          align="center"
          label="物料编号"
          show-overflow-tooltip
          width="120"/>
      <el-table-column
          prop="materialDesc"
          align="left"
          label="物料描述"
          min-width="120"
          show-overflow-tooltip/>
      <el-table-column prop="qty" align="center" label="采购数量" width="70"/>
      <el-table-column prop="planQty" align="center" label="已有计划数量" width="100"/>
      <el-table-column prop="actualQty" align="center" label="计划实收数量" width="100"/>
      <el-table-column prop="quantity" align="center" label="本次要货数量" width="100">
        <template v-slot="scope">
          <el-input v-model.trim="scope.row.quantity" placeholder="请输入" @input="checkQuantity(scope.row)"/>
        </template>
      </el-table-column>
      <el-table-column prop="requireDeliveryDate" align="center" label="需求日期" width="180">
        <template v-slot="scope">
          <el-date-picker
              v-model="scope.row.requireDeliveryDate"
              style="width: 150px"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
              placeholder="选择日期"/>
        </template>
      </el-table-column>
      <el-table-column prop="note" align="center" label="备注" width="150">
        <template v-slot="scope">
          <el-input v-model.trim="scope.row.note" placeholder="请输入"/>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          fixed="right"
          align="center"
          class-name="vm-table_operate"
          width="80">
        <template v-slot="scope">
          <el-button type="danger" @click="deleteRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="saveHandle">保存</el-button>
    </span>
    <purchase-plan-select ref="purchaseSelect" @select="purchaseSelect"/>
  </el-dialog>
</template>

<script>
  import purchasePlanSelect from "@/views/purchase/purchasePlan/PurchasePlanSelect";
  export default {
    components: {purchasePlanSelect},
    data() {
      return {
        dialogVisible: false,
        form: {
          details: [],
        },
        submitLoading: false,
        ruleValidate: {
          billTitle: {required: true, message: "标题不能为空",trigger: "blur"}},
      };
    },
    methods: {
      open(selection) {
        this.dialogVisible = true;
        selection.forEach(orderDetail => {
          let detail = {};
          detail.purchaseOrderNo = orderDetail.evaluate;
          detail.materialNo = orderDetail.partNo;
          detail.materialDesc = orderDetail.partNameSpec;
          detail.purchaseOrderId = orderDetail.mastPKID;
          detail.poDetailRowNo = orderDetail.rowNum;
          detail.qty = orderDetail.qty;
          detail.planQty = orderDetail.planQty;
          detail.actualQty = orderDetail.actualQty;
          this.form.details.push(detail);
        });
      },

      checkQuantity(row) {
        const reg = /^[0-9]*[1-9][0-9]*$/;
        if (!reg.test(row.quantity)) {
          this.$confirm("请输入大于0的整数", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
        if (row.quantity > row.qty - row.planQty) {
          this.$confirm("要货数量超过剩余数量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
      },
      // 删除行项
      deleteRow(index) {
        this.form.details.splice(index, 1);
      },
      // 新增行项
      purchaseSelect(detailList) {
        if(detailList) {
          detailList.forEach(orderDetail => {
            for (let item of this.form.details) {
              if (item.purchaseOrderNo === orderDetail.evaluate && item.poDetailRowNo === orderDetail.rowNum) {
                return;
              }
            }
            let detail = {};
            detail.purchaseOrderNo = orderDetail.evaluate;
            detail.materialNo = orderDetail.partNo;
            detail.materialDesc = orderDetail.partNameSpec;
            detail.purchaseOrderId = orderDetail.mastPKID;
            detail.poDetailRowNo = orderDetail.rowNum;
            detail.qty = orderDetail.qty;
            detail.planQty = orderDetail.planQty;
            detail.actualQty = orderDetail.actualQty;
            this.form.details.push(detail);
          });
        }else {
          this.$message.error("请勾选需要添加的行项！");
        }  
      },

      oneDelete(index) {
        this.form.details.splice(index, 1);
      },

      // 保存
      saveHandle() {
        this.$refs.form.validate(valid => {
          if (valid) {
            const arr = this.form.details.filter((item) => !item.quantity || !item.requireDeliveryDate);
            if (arr.length) {
              this.$confirm("请输入本次要货数量及需求日期", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.submitLoading = true;
            this.$http
              .post("basic", "purchasePlans", this.form)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style>
</style>
